import { init } from "@mta/apm-browser";
import { pandoraPlugin } from "@mta/apm-pandora";
import { vuePlugin } from "@mta/apm-vue";
import type { VueInstance } from "@mta/apm-types";
import type { PandoraSDKInterface } from "metaapp-pandora-sdk";
import OriginPandora from "metaapp-pandora-sdk";
import { createPerformanceResourceApp } from "@metaapp/performance-resource";
import {
  createAPMPlusSDK,
  type APMPlusSDKInstance,
  type CorePlugin
} from "@mta/apmplus-sdk";
import type { Primitive } from "@metaapp/types";
import { babel } from "../submodule/utils/jsb/index";

const { env, pandoraBaseUrl, pandoraIndexType, pandoraZone ,appId} = useConfig();
const sdkParam = {
  app_id: appId, //必填
  env:env.toLowerCase()
};

let apmInstance: APMPlusSDKInstance | undefined;

export function getApm() {
  return apmInstance;
}

export default defineNuxtPlugin((nuxtApp) => {
  try {
    const Pandora = OriginPandora.clone();
    Pandora.send(
      "config", 
      {
        index_type: pandoraIndexType,
        selfpackagename: "com.meta.web_tool_client",
        env: env.toLowerCase(),
        debug: false
      },
      {
        isMontageAppkey: true,
        appkey: "cDEwMTIw",
        zone: pandoraZone,
        baseUrl: pandoraBaseUrl,
        project_name:'item-mall-app'
      }
    );

    Pandora.send("start");

    const pandoraObj = Pandora as PandoraSDKInterface;
    const app = nuxtApp as unknown as VueInstance;
    init({
      debug: false,
      silentConsole: true,
      plugins: [pandoraPlugin(pandoraObj), vuePlugin(app)]
    });

    const date = Date.now();
    const { crsVersion } = useConfig();
    // 只在首次进入的时候执行，后续 spa 不执行
    nuxtApp.hook("app:mounted", () => {
      const endTime = Date.now();
      window.performance.metaMountedFinish({
        startTime: date,
        endTime
      });
      pandoraSend("event_isr_page_show", 'isr页面显示',{
        project_version: crsVersion,
        project_404: window.sysIs404 === true ? 1 : 0,
        project_name: "item-mall-app",
        project_route_path:window?.location?.pathname
      });
    });

    const toPandoraPayload = (data: Record<string, unknown>) => {
      const content =
        "raw_log_content" in data && typeof data.raw_log_content === "object"
          ? { ...(data.raw_log_content as Record<string, unknown>), ...sdkParam }
          : { ...data, ...sdkParam };
      return {
        raw_log_content: JSON.stringify(content)
      };
    };

    const pandoraBridgePlugin: CorePlugin = {
      name: "pandora-send-bridge",
      plugin(_core, { addEventListener }) {
        addEventListener("before-send", (data) => {
          pandoraSend(
            "apm_web_push",
            "web-performance性能数据",
            toPandoraPayload(data as Record<string, unknown>)
          );
          return false;
        });
      }
    };

   createPerformanceResourceApp({
      performance: {
        performance_resource:true,
      },
      pandora: {
        pandora:Pandora
      },
      plugins: [
        {
          plugin: (_send, { addEventListener }) => {
            addEventListener("before-send", function (option) {
              pandoraSend('web_performance_resource','performance_resource性能数据',option)
              return option;
            });
          },
          name: "webPerformance",
        },
      ],
    });
    apmInstance = createAPMPlusSDK({
      appId,
      env: env.toLowerCase() as "development" | "production" | "test",
      performance: {},
      pandora: {
        pandora: Pandora
      },
      autoTrackRouteChange: false,
      plugins: [pandoraBridgePlugin]
    });
    const apm = apmInstance;

    const handleBeforeUnload = (_e: BeforeUnloadEvent) => {
      // 这里写关闭页面的自定义逻辑（比如上报数据、清理缓存）
    };
    const handleRouteChange = () => {
      if (window) {
        apm.trackPageView();
        apm.trackResourceLoad();
      }
    };
    if (window) {
      window.addEventListener("beforeunload", handleBeforeUnload);
      nuxtApp.hook("page:finish", handleRouteChange);
      nuxtApp.hook("app:destroyed", () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        apm.destroy();
      });
    }
  } catch (error) {
  }
});
/**
 *
 * @param {*} kind kind
 * @param {*} desc desc
 * @param {*} sendparams sendparams
 * @returns {void}
 */
export function pandoraSend(kind: string, desc: string, sendparams: Record<string, Primitive>) {
  if (babel?.clientVersion && babel.clientVersion >= 7 && babel.clientType === "android") {
    babel.execAsync("clientTrackPoint", {
      kind,
      data: JSON.stringify(sendparams)
    });
  } else if (
    jsb &&
    ((window as any).MetaX || (window as any)?.webkit?.messageHandlers?.MetaX)
  ) {
    jsb?.execAsyncDataV2("nativeAnalytics", kind, desc, JSON.stringify(sendparams))
  } else {
    setTimeout(() => {
      pandora.send(kind, desc, sendparams);
    }, 10000);
  }
}